import { render, staticRenderFns } from "./empleados.vue?vue&type=template&id=314fa573&"
import script from "./empleados.vue?vue&type=script&lang=js&"
export * from "./empleados.vue?vue&type=script&lang=js&"
import style0 from "./empleados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports